import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enterprice-sass-header',
  templateUrl: './enterprice-sass-header.component.html',
  styleUrls: ['./enterprice-sass-header.component.scss']
})
export class EnterpriceSassHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
